(function () {
  class ReelSpinnerVisualStacked extends SlotsEngine.types.ReelSpinnerVisual {
    constructor(
      reelId,
      name,
      maxAppertureHeight,
      slotMach,
      minSpacing,
      reservedSpace,
      numPreApp,
      numPostApp,
      layout,
      stackedSymbols
    ) {
      super(
        reelId,
        name,
        maxAppertureHeight,
        slotMach,
        minSpacing,
        reservedSpace,
        numPreApp,
        numPostApp
      );
      this.reelId = parseInt(reelId.replace("reel", ""));
      this._layout = layout;
      this.uniqueCoins = [];
      this.initialiseSymbolOffsets();
      this._stackedSymbols = stackedSymbols;
      this._symbolSizes = [];
      this.prevCoinValues = [];
      this.newSpin = false;
      this.reelCoinValues = [];
      this.initialiseSymbolSizes(resourceManager.configuration["symbols"]);
      this._symbolMovieName += "_" + layout;
      this._symbolMovieDescriptors += "_" + layout;
      this._blockData = [];
      this.valueLocked = 0;
      this.moonValueLocked = 0;
      this._fireballMovies = [];
      this.reelMoonValues = [];
      this._moonValueOverlays = [];
      this.uniqueMoons = [];
      messageBus.subscribe("spinner:SpinEventStarted", this.onSpin.bind(this));
      this._lockedCashValues = false;

      this._ready = false;

      Reflex.registerEventHandler(
        "orientationChange",
        this.onOrientationChange.bind(this)
      );
      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
    }

    onGameConfigEvent() {
      this._ready = true;
    }

    // incase symbols are different size canvases like glows etc
    initialiseSymbolSizes(symbolData) {
      this._symbolSizes = new Array(Object.keys(symbolData).length).fill({
        x: 0,
        y: 0,
      });
      for (let prop in symbolData) {
        if (symbolData.hasOwnProperty(prop) && symbolData[prop].imageSize) {
          let data = symbolData[prop];
          this._symbolSizes[Number(data.ID)] = data.imageSize;
        }
      }

      // if (this._symbolGfxObjects.length > 0) {
      //   this.scaleToImageSize();
      // }
    }

    onSpin() {
      const self = this;
      this.uniqueCoins = [];
      this.uniqueMoons = [];

      let symData = this._reelSpinnerData.getSymbolData();

      this.uniqueCoins = this.reelCoinValues;
      this.uniqueMoons = this.reelMoonValues;

      for (let i = 0; i < this.uniqueCoins.length; i++) {
        for (let j = 0; j < symData.length; j++) {
          if (this.uniqueCoins[i].row === j) {
            this.uniqueCoins[i].uniqueId = symData[j].uniqueId;
          }
        }
      }

      for (let i = 0; i < this.uniqueMoons.length; i++) {
        for (let j = 0; j < symData.length; j++) {
          if (this.uniqueMoons[i].row === j) {
            this.uniqueMoons[i].uniqueId = symData[j].uniqueId;
          }
        }
      }

      this.newSpin = true;
      this.updateCount = 0;

      this.reelCoinValues = [];
      this.reelMoonValues = [];

      gameController.coinValues.forEach(function (coin) {
        if (coin.reel === self.reelId) {
          self.reelCoinValues.push(coin);
        }
      });

      gameController.moonValues.forEach(function (moon) {
        if (moon.reel === self.reelId) {
          self.reelMoonValues.push({
            value: moon.numberOfSpins,
            slotCell: moon.slotCell,
            row: moon.row,
          });
        }
      });
    }

    assignSlotMachine(newSlot) {
      super.assignSlotMachine(newSlot);

      const self = this;
      newSlot.subscribeToNewSymbolEvent(function (reelId, symbolId) {
        if (reelId === self._reelSpinnerData._reelId) {
          // we need to assign the new symbols to the gfxTextures because
          // we get notified of a new symbol before we have updated the textures
          //so if we are looking at things like texture width they point to the old symbol not new one
          self.redraw();
        }
      });

      newSlot.subscribeToSpinAbortedEvent(function () {
        self.redraw();
      });

      newSlot.subscribeToSymbolChangedEvent(function (reelId) {
        if (reelId === self._reelSpinnerData._reelId) {
          self.redraw();
        }
      });

      newSlot.subscribeToReelsLandedEvent(function (reelId) {
        if (reelId === self._reelSpinnerData._reelId) {
          self.redraw();
        }
      });

      this.redraw();
    }

    redraw() {
      this.updateSymbols();

      //this.scaleToImageSize();
      if (
        !gameController.slamStopped &&
        !gameController.inCashLink &&
        !gameController.inCoinAwardsModifier &&
        !gameController.wasCashLink
      ) {
        this.addValueToCoin();
        this.addValueToMoon();
      } else {
        gameController.valuesSpin.clearAllSpinMoonValues();
      }
      this.updateClipRects();
    }

    updateSymbols() {
      let symbolData = this._reelSpinnerData.getSymbolData();

      let ids = [];
      let positions = [];
      for (let i = 0; i < symbolData.length; ++i) {
        if (gameController.inBuyABonus) {
          if (
            buyBonusPopup.cashLinkSelected &&
            symbolData[i].symId === gameData.symbols["Symbol_Moon"].ID
          ) {
            symbolData[i].symId = Math.floor(Math.random() * (8 - 0 + 1) + 0);
          }
        }

        if (gameController.gameLoaded) {
          let stake = resourceManager
            .getController("stakeController")
            .getCurrentStake("default");
          if (
            i === 4 &&
            gameData.credit < stake &&
            (symbolData[i].symId === gameData.symbols["Symbol_Wild_1x2"].ID ||
              symbolData[i].symId === gameData.symbols["Symbol_Wild_1x3"].ID ||
              symbolData[i].symId === gameData.symbols["Symbol_Wild_1x4"].ID)
          ) {
            symbolData[i].symId = Math.floor(Math.random() * (8 - 0 + 1) + 0);
          }
        }
        ids.push(symbolData[i].symId);

        let offset = this._symbolOffset[symbolData[i].symId];
        let yPos = symbolData[i].yPos + offset.y;
        positions.push({ x: offset.x, y: yPos });

        if (this._oversizedSymbolIds.indexOf(symbolData[i].symId) !== -1) {
          this.setChildIndex(
            this._symbolGfxObjects[i],
            this.children.length - 1
          );
        }
      }
      this.updateSymbolIds(ids);
      this.updateSymbolPositions(positions);
    }

    addValueToCoin() {
      if (gameController.gameLoaded) {
        let symbolData = this._reelSpinnerData.getSymbolData();
        for (let i = 0; i < this._symbolGfxObjects.length; ++i) {
          let symId = symbolData[i].symId;
          if (i < 4 && gameController.reelStopping[this.reelId] === false) {
            let slotCell = this.reelId * gameData.numRows + i;
            gameController.valuesSpin.showSpinCoinValue(false, slotCell);
            gameController.valuesSpin.hideAllSpinPots(slotCell);
            if (gameData.symbols["Symbol_Power_Pack_Total"].ID === symId) {
              gameController.valuesSpin.setCoinCLSpinValue(
                this.reelId,
                gameController.ppTotalSymbolValue
              );
              gameController.valuesSpin.showSpinCLCoinValue(true, this.reelId);
            }
            if (symId === gameData.symbols["Symbol_Coin"].ID) {
              if (symbolData[i].yPos === 0) {
                let isDuplicate = false;
                for (let j = 0; j < this.uniqueCoins.length; j++) {
                  if (symbolData[i].uniqueId === this.uniqueCoins[j].uniqueId) {
                    isDuplicate = true;
                  }
                }
                if (!isDuplicate) {
                  let stake = gameController.getCurrentModeStake(true);
                  const baseVal =
                    gameData.possibleCashValues[
                      Math.floor(Math.random() * (6 - 0 + 1) + 0)
                    ];
                  let value = (baseVal * stake) / 100;
                  this.uniqueCoins.push({
                    amount: value,
                    uniqueId: symbolData[i].uniqueId,
                    type: "Cash",
                  });
                }
              }
              for (let j = 0; j < this.uniqueCoins.length; j++) {
                if (this.uniqueCoins[j].uniqueId === symbolData[i].uniqueId) {
                  if (!gameController.slamStopped) {
                    if (this.uniqueCoins[j].type === "Cash") {
                      gameController.valuesSpin.setCoinSpinValue(
                        slotCell,
                        this.uniqueCoins[j].amount
                      );
                      gameController.valuesSpin.showSpinCoinValue(
                        true,
                        slotCell
                      );
                    } else {
                      gameController.valuesSpin.showSpinPotValue(
                        true,
                        slotCell,
                        this.uniqueCoins[j].potName
                      );
                    }
                  }
                }
              }
            }
          } else if (
            //ELSE:If the coins are landing: we need need to put in the landed results recieved from server
            i < 4 &&
            gameController.reelStopping[this.reelId] === true &&
            this._reelSpinnerData._reelSpinning
          ) {
            let slotCell = this.reelId * gameData.numRows + i;
            gameController.valuesSpin.showSpinCoinValue(false, slotCell);
            gameController.valuesSpin.hideAllSpinPots(slotCell);
            if (
              symbolData[i].yPos === 0 &&
              symbolData[i].symId === gameData.symbols["Symbol_Coin"].ID
            ) {
              let isDuplicate = false;
              //Need to reverse the results as the bottom result will come into view first
              for (let j = this.reelCoinValues.length - 1; j >= 0; j--) {
                if (this.uniqueCoins.length > 0) {
                  for (let k = 0; k < this.uniqueCoins.length; k++)
                    if (this.uniqueCoins[k].uniqueId) {
                      isDuplicate = true;
                    }
                }
                if (!isDuplicate) {
                  this.uniqueCoins.push({
                    amount: this.reelCoinValues[j].amount,
                    uniqueId: symbolData[i].uniqueId,
                    type: this.reelCoinValues[j].type,
                    potName: this.reelCoinValues[j].potName,
                  });
                }
              }
              for (let j = 0; j < this.uniqueCoins.length; j++) {
                //we check to here to show the results on the landed coin symbols
                if (this.uniqueCoins[j].uniqueId === symbolData[i].uniqueId) {
                  if (!gameController.slamStopped) {
                    if (this.uniqueCoins[j].type === "Cash") {
                      gameController.valuesSpin.setCoinSpinValue(
                        slotCell,
                        this.uniqueCoins[j].amount
                      );
                      gameController.valuesSpin.showSpinCoinValue(
                        true,
                        slotCell
                      );
                    } else {
                      gameController.valuesSpin.showSpinPotValue(
                        true,
                        slotCell,
                        this.uniqueCoins[j].potName
                      );
                    }
                  }
                }
              }
            }
          } else {
            if (i > 4) {
              for (let j = 0; j < this.uniqueCoins.length; j++) {
                if (symbolData[i].uniqueId === this.uniqueCoins[j].uniqueId) {
                  this.uniqueCoins.splice(j, 1);
                }
              }
            }
          }
        }
      }
    }

    updateSymbolIds(ids) {
      super.updateSymbolIds(ids);

      if (gameController.gameLoaded) {
        for (let i = 0; i < ids.length; ++i) {
          let slotCell;
          if (i < 4) {
            slotCell = this.reelId * gameData.numRows + i;
          }
          let symId = ids[i];
          if (gameData.symbols["Symbol_Power_Pack_Total"].ID === symId) {
            if (i < 4) {
              let ppSlotCell = this.reelId * gameData.numRows + i;
              gameController.valuesSpin.setCoinSpinValue(
                ppSlotCell,
                gameController.ppTotalSymbolValue
              );
              gameController.valuesSpin.showSpinCoinValue(true, ppSlotCell);
            }
          }
        }
      }
    }

    setUniqueValues(type, data) {
      let symbolData = this._reelSpinnerData.getSymbolData();
      for (let i = 0; i < this._symbolGfxObjects.length; ++i) {
        let symId = symbolData[i].symId;
        if (type === "moon") {
          if (symId === gameData.symbols["Symbol_Moon"].ID && i === data.row) {
            this.uniqueMoons.push({
              value: data.numberOfSpins,
              uniqueId: symbolData[i].uniqueId,
            });
          }
        } else if (type === "coin") {
          if (symId === gameData.symbols["Symbol_Coin"].ID && i === data.row) {
            this.uniqueCoins.push({
              amount: data.amount,
              uniqueId: symbolData[i].uniqueId,
              type: data.type,
              potName: data.potName,
            });
          }
        } else {
          if (
            symId === gameData.symbols["Symbol_Power_Pack"].ID &&
            i === data.row
          ) {
            this.uniqueCoins.push({
              amount: gameController.ppTotalSymbolValue,
              uniqueId: symbolData[i].uniqueId,
              type: data.type,
            });
          }
        }
      }
    }

    addValueToMoon() {
      if (gameController.gameLoaded) {
        let symbolData = this._reelSpinnerData.getSymbolData();
        for (let i = 0; i < this._symbolGfxObjects.length; ++i) {
          let symId = symbolData[i].symId;
          //IF:While the reels are spinning we need to put in dummy values
          if (i < 4 && gameController.reelStopping[this.reelId] === false) {
            let slotCell = this.reelId * gameData.numRows + i;
            gameController.valuesSpin.showSpinMoonValue(false, slotCell);
            if (symId === gameData.symbols["Symbol_Moon"].ID) {
              if (symbolData[i].yPos === 0) {
                let isDuplicate = false;

                for (let j = 0; j < this.uniqueMoons.length; j++) {
                  //IF: There is a value attached to the uniqueID we dont want to change it
                  if (this.uniqueMoons[j].uniqueId) {
                    isDuplicate = true;
                  }
                }
                //IF: There is a symbol that doesnt have a value attached we push to the unique array for reference
                if (!isDuplicate) {
                  let value = Math.floor(Math.random() * (4 - 1 + 1) + 1);
                  this.uniqueMoons.push({
                    value: value,
                    uniqueId: symbolData[i].uniqueId,
                  });
                }
              }
              for (let j = 0; j < this.uniqueMoons.length; j++) {
                //Here we iterate through the populated unique symbol data to pass through to the showMoon function
                if (this.uniqueMoons[j].uniqueId === symbolData[i].uniqueId) {
                  if (!gameController.slamStopped) {
                    gameController.valuesSpin.showSpinMoonValue(
                      true,
                      slotCell,
                      this.uniqueMoons[j].value
                    );
                  }
                }
              }
            }
          } else if (
            //ELSE:If the moons are landing: we need need to put in the landed results recieved from server
            i < 4 &&
            gameController.reelStopping[this.reelId] === true &&
            this._reelSpinnerData._reelSpinning
          ) {
            let slotCell = this.reelId * gameData.numRows + i;
            gameController.valuesSpin.showSpinMoonValue(false, slotCell);
            if (
              symbolData[i].yPos === 0 &&
              symbolData[i].symId === gameData.symbols["Symbol_Moon"].ID
            ) {
              let isDuplicate = false;
              //Need to reverse the results as the bottom result will come into view first
              for (let j = this.reelMoonValues.length - 1; j >= 0; j--) {
                if (!this.reelMoonValues[j].assigned) {
                  for (let k = 0; k < this.uniqueMoons.length; k++) {
                    if (
                      this.uniqueMoons[k].uniqueId === symbolData[i].uniqueId
                    ) {
                      isDuplicate = true;
                    }
                  }
                  if (!isDuplicate) {
                    this.uniqueMoons.push({
                      value: this.reelMoonValues[j].value,
                      uniqueId: symbolData[i].uniqueId,
                    });
                    this.reelMoonValues[j].assigned = true;
                  }
                }
              }
            }
            for (let j = 0; j < this.uniqueMoons.length; j++) {
              //we check to here to show the results on the landed moon symbols
              if (this.uniqueMoons[j].uniqueId === symbolData[i].uniqueId) {
                if (!gameController.slamStopped) {
                  gameController.valuesSpin.showSpinMoonValue(
                    true,
                    slotCell,
                    this.uniqueMoons[j].value
                  );
                }
              }
            }
          } else {
            //IF the symbol is out of view (i>4) then we need to remove the unique reference to prevent futher visiabilty of the value
            if (i > 4) {
              for (let j = 0; j < this.uniqueMoons.length; j++) {
                if (symbolData[i].uniqueId === this.uniqueMoons[j].uniqueId) {
                  this.uniqueMoons.splice(j, 1);
                }
              }
            }
          }
        }
      }
    }

    isStackedSymbols(symId) {
      return this._stackedSymbols.indexOf(symId) !== -1;
    }

    getSymbolStackSize(symId) {
      for (let i = 0; i < this._stackedSymbols.length; ++i) {
        if (this._stackedSymbols[i].id == symId)
          return this._stackedSymbols[i].stackSize;
      }
      return 1;
    }

    onOrientationChange() {
      //this.scaleToImageSize();
    }

    scaleToImageSize() {
      // KEEP FOR NOW
      // let symbolData = this._reelSpinnerData.getSymbolData();
      // for (let i = 0; i < this._symbolGfxObjects.length; ++i) {
      //   let symId = symbolData[i].symId;
      //   let width = this._symbolGfxObjects[i].symbol.texture.width;
      //   let height = this._symbolGfxObjects[i].symbol.texture.height;
      //   let x = this._symbolSizes[symId].x / width;
      //   let y = this._symbolSizes[symId].y / height;
      //   this._symbolGfxObjects[i].scale.set(x, y);
      // }
    }

    // for over hanging symbols etc
    initialiseSymbolOffsets() {
      if (this._layout)
        super.initialiseSymbolOffsets(resourceManager.configuration["symbols"]);
    }

    analyseStacksOnReel(reel) {
      let res = [];
      for (let i = 0; i < reel.length; ) {
        let symId = reel[i];
        let symStackSize = this.getSymbolStackSize(symId);
        let isStackedSymbol = symStackSize > 1;
        let count = 1;

        for (let j = 1; j < symStackSize && i + j < reel.length; ++j) {
          if (isStackedSymbol && reel[i + j] == symId) {
            ++count;
          } else {
            break;
          }
        }

        let offset = i === 0 ? symStackSize - count : 0;

        res.push({
          row: i,
          count: count,
          symId: symId,
          blockSize: isStackedSymbol ? symStackSize : 1,
          offset: offset,
        });
        i += count;
      }
      return res;
    }

    // we dont render one big gigablox symbol. We actual render a clipped section of it. Despite how many symbols are
    // in view for this particular reel the reel itself will still be made up of 6 rows (standard gigablox layout is 6x6).
    // so if there is a 3x3 symbol in view at the top of the window, row 0 will show the top third of the symbol, row 1 middle third,
    // row 2 bottom third. This is done via cliprects. The reason for this is the ReelSpinner knows nothing about gigablox and doesnt
    // need to as it is just added complexity to the data class so the renderer needs to infer it from the data.
    updateClipRects() {
      let symbolData = this._reelSpinnerData.getSymbolData(); // symbols that need to be drawn
      this._blockData = this.calcBlockData();
      for (let i = 0; i < symbolData.length; ++i) {
        let stackSize = this.getSymbolStackSize(symbolData[i].symId);
        let imageSize = this._symbolSizes[symbolData[i].symId]; // size of the sprite (the actual gigablox size)
        let symbolHeight = imageSize.y / stackSize; // height of a 1x1 symbol, cant use minSymbolSpacing due to symbols with bigger texture  heights (see 6x6 bonus symbol on hunters moon)
        let blockOffset = symbolHeight * this._blockData[i]; // height of this symbol based on the size of the gigablox

        let scale = this._symbolGfxObjects[i].scale;
        this._symbolGfxObjects[i].symbol.mask.clear();
        this._symbolGfxObjects[i].symbol.mask.beginFill(0x000000, 0);

        let width = imageSize.x / scale.x;
        let left = -(width / 2);
        let top =
          blockOffset / scale.y + this._symbolOffset[symbolData[i].symId].y;
        let height =
          imageSize.y / scale.y / stackSize +
          1 -
          this._symbolOffset[symbolData[i].symId].y; // + 1 because we need to make the clip rect 1 pixel high otherwise on none native aspect ratios you can get a pixel slice between the symbols

        top -= symbolHeight / 2;
        if (stackSize === 4) {
          top -= symbolHeight * 1.5;
        } else if (stackSize === 3) {
          top -= symbolHeight;
        } else if (stackSize === 2) {
          top -= symbolHeight;
          height += symbolHeight / 2;
        }

        this._symbolGfxObjects[i].symbol.mask.drawRect(
          left,
          top,
          width,
          height
        );
        this._symbolGfxObjects[i].symbol.mask.endFill();
      }
    }

    calcBlockData() {
      let blockInfo = [];

      let data = this._reelSpinnerData.getSymbolData();
      let symbs = [];
      for (let i = 0; i < data.length; ++i) {
        symbs.push(data[i].symId);
      }

      blockInfo = this.analyseStacksOnReel(symbs);

      let remainingRows = this._reelSpinnerData.getMaxSymbolsInWindow();
      let res = [];

      if (!blockInfo) {
        blockInfo = this.analyseStacksOnReel(symbs);
      }

      for (let i = 0; i < blockInfo.length; ++i) {
        let block = blockInfo[i];
        let numToDraw = Math.min(block.count, remainingRows);

        let startOffset = block.offset;
        for (let j = 0; j < numToDraw; ++j) {
          res.push(startOffset + j);
        }

        remainingRows -= numToDraw;
      }

      let lastWindowSymOffset = res[res.length - 1];

      // handle preapp
      if (blockInfo[0].offset === 0) {
        // if next symbol is stacked
        let preappSymId = symbs[this._reelSpinnerData._preAppertureSymbolIdx];
        let ss = this.getSymbolStackSize(preappSymId);
        res.push(ss - 1);
      } else {
        res.push(blockInfo[0].offset - 1); // preapp should be symbol above this in the stack
      }

      // handle postapp
      let lastSymIdx = this._reelSpinnerData._preAppertureSymbolIdx - 1;
      let lastSymInWindow = symbs[lastSymIdx];
      let lastSymSS = this.getSymbolStackSize(lastSymInWindow);

      if (lastSymSS === 1) {
        res.push(0);
      } else {
        if (
          lastSymInWindow !==
          symbs[this._reelSpinnerData._postAppertureSymbolIdx]
        ) {
          res.push(0);
        } else {
          res.push(lastWindowSymOffset + 1);
        }
      }

      return res;
    }

    updateSymbolPositions(positions) {
      let symbolData = this._reelSpinnerData.getSymbolData(); // symbols that need to be drawn
      let symbolHeight = this._reelSpinnerData._minSymbolSpacing;
      for (let i = 0; i < positions.length; ++i) {
        const { symId } = symbolData[i];
        const stackSize = this.getSymbolStackSize(symId);
        const pos = positions[i];
        let yPos = pos.y;
        const xPos = pos.x;
        const symbolGfx = this._symbolGfxObjects[i];

        // Base offset for clipping (1px avoids artifacts on non-native aspect ratios)
        let blockOffset = symbolHeight * this._blockData[i] + 1;
        const wildHeight = 134;
        // Adjust block offset based on stack size
        if (gameData.symbols) {
          if (symbolData[i].symId === gameData.symbols["Symbol_Wild_1x1"]?.ID) {
            blockOffset += 2;
          }
        }

        switch (stackSize) {
          case 4:
            blockOffset -= wildHeight * 1.5;
            break;
          case 3:
            blockOffset -= wildHeight - 2;
            break;
          case 2:
            blockOffset -= wildHeight / 2 - 2;
            break;
          default:
            // No offset adjustment for other cases
            break;
        }
        // Placeholder for future logic specific to reel1 (e.g., wild stacks)
        if (this._reelSpinnerData._reelId === "reel1") {
          // TODO: Add handling for wild stacks
        }

        yPos -= blockOffset;

        // Update symbol position
        symbolGfx.position.setX(xPos);
        symbolGfx.position.setY(yPos);
      }
    }
  }

  function createStacked(json) {
    let sm = resourceManager.getController(json.slotMachineName);
    let reservedSpace = json.slotMachineName === "SlotMachineColossal" ? 8 : 4;
    return new ReelSpinnerVisualStacked(
      json.ID,
      json.ID + " container",
      json.appertureHeight,
      sm,
      json.minSymbolSpacing,
      reservedSpace,
      1,
      1,
      json.stackLayout,
      json.stackedSymbols
    );
  }

  function initialiseStacked(json, reelSpinnerVisual) {
    reelSpinnerVisual._slotMachineName = json.slotMachineName;

    let i = reelSpinnerVisual._reelSpinnerData._reservedSpace;
    let jsonObj = {
      format: "list",
      files: [],
    };

    let textureListsName = "symbols";
    var symbolsList = resourceManager.getConfiguration()[textureListsName];
    for (var prop in symbolsList) {
      if (typeof symbolsList[prop] === "object") {
        // Add the first texture of each symbol
        let texture = textureParser.getTextureList(
          symbolsList[prop].texture
        )[0];
        jsonObj.files.push(
          texture.textureCacheIds[0].replace(ReflexLoader.rootResDir, "")
        );
      }
    }

    textureParser.addTextureList(textureListsName, jsonObj);
    textureParser.getTextureList(textureListsName);

    reelSpinnerVisual.initialise(json, reelSpinnerVisual);

    for (let i = 0; i < reelSpinnerVisual._symbolGfxObjects.length; ++i) {
      reelSpinnerVisual._symbolGfxObjects[i].symbol.mask = new PIXI.Graphics();
      reelSpinnerVisual._symbolGfxObjects[i].symbol.mask.beginFill(0x000000, 0);
      reelSpinnerVisual._symbolGfxObjects[i].symbol.mask.drawRect(
        0,
        0,
        218,
        142
      );
      reelSpinnerVisual._symbolGfxObjects[i].symbol.mask.endFill();
      reelSpinnerVisual._symbolGfxObjects[i].symbol.addChild(
        reelSpinnerVisual._symbolGfxObjects[i].symbol.mask
      );
    }
  }

  function getRequiredFilesStacked() {
    return [
      ...textureParser.getFilesRequired("Symbol_10"),
      ...textureParser.getFilesRequired("Symbol_J"),
      ...textureParser.getFilesRequired("Symbol_Q"),
      ...textureParser.getFilesRequired("Symbol_K"),
      ...textureParser.getFilesRequired("Symbol_A"),
      ...textureParser.getFilesRequired("Stag"),
      ...textureParser.getFilesRequired("Eagle"),
      ...textureParser.getFilesRequired("Bear"),
      ...textureParser.getFilesRequired("Wolf"),
      ...textureParser.getFilesRequired("Symbol_Coin"),
      ...textureParser.getFilesRequired("Symbol_Power_Pack"),
      ...textureParser.getFilesRequired("Symbol_Wild_1x1"),
      ...textureParser.getFilesRequired("Symbol_Wild_1x2"),
      ...textureParser.getFilesRequired("Symbol_Wild_1x3"),
      ...textureParser.getFilesRequired("Symbol_Wild_1x4"),
      ...textureParser.getFilesRequired("Symbol_Moon"),
      ...textureParser.getFilesRequired("Symbol_Cashlink"),
      ...textureParser.getFilesRequired("volumeButtons"),
      ...textureParser.getFilesRequired("volumeButtonsPortrait"),
    ];
  }

  resourceManager.registerObjectType(
    "ReelSpinnerVisualStacked",
    createStacked,
    initialiseStacked,
    getRequiredFilesStacked
  );
})();
